import React from 'react';

import { Text } from '@/components/shared/element/text';
import { Box } from '@/components/shared/layout/box';
import { styled } from '@/stitches.config';
import { IThemeLCV } from '@/types/shared';

export const Tooltip = styled(Box, {
  left: '-$space-1',
  bottom: 'calc(100% + $space-1)',
  '&::before, &::after': {
    content: '""',
    position: 'absolute',
    borderRadius: '$rounded-1',
  },
  '&::before': {
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
  },
  '&::after': {
    width: 14,
    height: 14,
    left: 'calc(4 + 4)',
    transform: 'scaleX(0.8) rotate(-45deg)',
  },
  [`& ${Text}`]: {
    minHeight: '1.5em',
    minWidth: '1em',
  },
  variants: {
    theme: {
      light: {
        '&::before, &::after': {
          background: '$gray700',
        },
      },
      dark: {
        '&::before, &::after': {
          content: '""',
          position: 'absolute',
          background: '$gray300',
        },
      },
    },
  },
  defaultVariants: {
    theme: 'light',
  },
});

interface TooltipProps {
  msg: string;
  theme?: IThemeLCV;
}

const View: React.FC<TooltipProps> = ({
  msg,
  theme = 'light',
}: TooltipProps) => {
  return (
    <Tooltip
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      theme={theme}
      position="absolute"
      padding="2"
      zIndex="2"
      test={{
        dataTest: 'tooltip',
      }}
    >
      <Text
        variant={theme === 'light' ? 'text-white' : 'text-gray-darkest'}
        size="text-body-2"
      >
        {msg}
      </Text>
    </Tooltip>
  );
};

export default View;
